module.exports = __webpack_public_path__ + "img/tipocontacto06.c0de116.svg";